import React, { createContext } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
// we explicitly don't provide a fallback default as toast type must be provided
var ToastContext = /*#__PURE__*/createContext(null);
function ToastProvider(_ref) {
  var toastType = _ref.toastType,
    children = _ref.children;
  return /*#__PURE__*/_jsx(ToastContext.Provider, {
    value: toastType,
    children: children
  });
}
export { ToastProvider, ToastContext };